import React from 'react';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: theme.spacing(2),
  },
  sectionButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '1 0 0',
  },
  blue: {
    color: theme.palette.facet.primaryBlue,
  },
  gray: {
    color: theme.palette.facet.primaryGray,
  },
}));

export default function SectionHeader({
  title,
  onHeaderClick,
  iconClassName,
  color,
}) {
  const classes = useStyles();
  return (
    <div
      className={classnames({
        [classes.sectionHeader]: true,
        [classes.blue]: color === 'primaryBlue',
        [classes.grey]: color === 'primaryGray',
      })}
      onClick={onHeaderClick}
      role="presentation"
    >
      <Typography variant="body1">{title}</Typography>
      <div className={classes.sectionButton}>
        <Icon className={iconClassName} style={{ fontSize: '14px' }} />
      </div>
    </div>
  );
}

SectionHeader.propTypes = {
  onHeaderClick: PropTypes.func,
  title: PropTypes.string,
  iconClassName: PropTypes.string,
  color: PropTypes.string,
};

SectionHeader.defaultProps = {
  onHeaderClick: () => {},
  title: '',
  iconClassName: 'fa fa-plus-circle',
  color: 'primaryBlue',
};
